import { Divider, Popover } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import ColorButton from "components/common/ColorButton";
import SwitchLanguage from "components/common/SwitchLanguage";
import NotificationIcon from "components/notification/NotificationIcon";
import UserAvatar from "components/user/UserAvatar";
import UserName from "components/user/UserName";
import UserRole from "components/user/UserRole";
import {
  drawerWidth,
  notificationTime,
  platformName,
} from "libs/configs/constant";
import { HOME_TAB } from "libs/constant/Step";
import { logoutRedirect } from "libs/utils/auth";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { setHomeTab } from "redux/modules/uiSlice";
import {
  getNotifications,
  readNotifications,
  selectUnReadNotification,
  trashNotifications,
} from "redux/modules/userNotificationSlice";
import { getSmartForm, setSmartServiceId } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
  },
  list: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  logoutButton: {
    marginTop: theme.spacing(2),
  },
  emp: {
    display: "flex",
    flex: 1,
  },
  fullList: {},
  listItemText: {
    color: theme.palette.common.white,
  },
  line: {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
  userInfoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  // ----
  rowMenuPopOver: {
    // padding: 15,
    width: 350,
  },
  rowPopTitle: {
    padding: "15px",
    borderBottom: "1px solid lightgray",
    fontWeight: "500",
    color: "white",
    textAlign: "center",
    backgroundColor: "#F53C56",
    marginBottom: 15,
  },
  rowPopItem: {
    display: "flex",
    padding: "10px 15px",
    borderBottom: "1px solid lightgray",
  },
  firstItem: {
    flex: 1,
  },
  itemTitle: {
    color: "#5F5F5F",
    fontWeight: "bold",
  },
  itemDesc: {
    color: "#5F5F5F",
    fontSize: "0.8rem",
    paddingTop: "10px",
    fontWeight: "500",
  },
  itemDate: {
    color: "#ABAFC9",
    fontSize: "0.8rem",
    paddingTop: "10px",
    fontWeight: "500",
  },
  secItem: {
    width: 23,
    color: "#F53C56",
    cursor: "pointer",
  },
  noNoti: {
    textAlign: "center",
    color: "#ABAFC9",
    paddingBottom: "18px",
  },
}));

function UserInfoSection({ count = 0, onClickNoti = () => {} }) {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.flexRow}>
        <SwitchLanguage />
        <div onClick={onClickNoti}>
          <NotificationIcon className={classes.userInfo} count={count} />
        </div>
      </div>
      <div className={classes.userInfoSection}>
        <UserAvatar size={7} />
        <UserName />
        <UserRole />
      </div>
    </div>
  );
}

export default function SidebarLeft(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const isOfflineLogin = useSelector((state) => state.auth.isOfflineLogin);

  const { list: notifications } = useSelector(
    (state) => state.userNotification
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const unread = useSelector(selectUnReadNotification);
  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(getNotifications());
    const interval = setInterval(() => {
      dispatch(getNotifications());
    }, notificationTime);
    return () => clearInterval(interval);
  }, [dispatch]);

  const handleClickLogout = () => {
    if (isOfflineLogin) {
      history.replace("/logout");
    } else {
      logoutRedirect();
    }
  };

  const handleDrawerClose = () => {
    props.onDrawerClose();
  };

  const popoverClick = async (e) => {
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(e.currentTarget);
      if (unread.length > 0) {
        const body = {
          deviceId: platformName,
          notificationIds: unread.map((x) => x.notificationId),
        };
        await dispatch(readNotifications(body));
        await dispatch(getNotifications());
      }
    }
  };

  const popoverLeave = async () => {
    setAnchorEl(null);
  };

  const removeNotificaiton = async (notificationId) => {
    const body = {
      deviceId: platformName,
      notificationIds: [notificationId],
    };

    await dispatch(trashNotifications(body));
    await dispatch(getNotifications());
  };

  const handleClickNotiItem = (noti) => () => {
    if (noti.type === "RequestDocuments" && noti?.data !== null) {
      try {
        const notiData = JSON.parse(noti.data);

        setAnchorEl(null);
        dispatch(setHomeTab(HOME_TAB.HISTORY));
        dispatch(setSmartServiceId(notiData.smartServiceId));
        dispatch(
          getSmartForm({
            personalId: notiData.personalId,
            smartserviceId: notiData.smartServiceId,
            draftId: notiData.draftId,
          })
        );
      } catch (e) {
        console.log("handleClickNotiItem ", e);
      }
    }
    if (noti.type === "Stamped" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/appointment/${notiData?.DraftId}`);
    }
    if (noti.type === "ConfirmStamped" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/appointment/${notiData?.DraftId}?stamped=1`);
    }

    if (noti.type === "FinalApproved" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/appointment/${notiData?.draftId}`);
    }

    if (noti.type === "ApprovedStamp" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/appointment/${notiData?.DraftId}?stamped=1`);
    }
  };

  return (
    <div style={{ width: drawerWidth }}>
      <Drawer
        variant="permanent"
        anchor="left"
        BackdropProps={{ invisible: true }}
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        {...props}
      >
        <div className={classes.list}>
          <UserInfoSection
            onClickNoti={(e) => popoverClick(e)}
            count={unread.length}
          />
          <Divider className={classes.line} />
          <div className={classes.emp} />
          <ColorButton
            fullWidth
            variant="contained"
            color="error"
            className={classes.logoutButton}
            onClick={handleClickLogout}
          >
            logout
          </ColorButton>
        </div>

        <Popover
          className={classes.popover}
          classes={{
            paper: classes.popoverContent,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={popoverLeave}
        >
          <div className={classes.rowMenuPopOver}>
            <div className={classes.rowPopTitle}>Notifications</div>
            {notifications.length > 0 &&
              notifications.map((noti, index) => (
                <div
                  key={noti.notificationId}
                  className={classes.rowPopItem}
                  style={{
                    cursor: noti.data !== null ? "pointer" : "default",
                  }}
                  onClick={handleClickNotiItem(noti)}
                >
                  <div className={classes.firstItem}>
                    <div className={classes.itemTitle}>{noti.title}</div>
                    <div className={classes.itemDesc}>{noti.description}</div>
                    <div className={classes.itemDate}>{noti.createDate}</div>
                  </div>
                  <div
                    className={classes.secItem}
                    onClick={() => removeNotificaiton(noti.notificationId)}
                  >
                    <DeleteIcon />
                  </div>
                </div>
              ))}
            {notifications.length === 0 && (
              <div className={classes.noNoti}>No notifications yet</div>
            )}
          </div>
        </Popover>
      </Drawer>
    </div>
  );
}
